import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Antenna, CheckCircle2, AlertTriangle, Thermometer } from 'lucide-react';
import { coax } from '@/lib/api';
import { PageHeader } from '@/components/ui/PageHeader';

export default function CoaxMasters() {
  const navigate = useNavigate();
  const { data: list, isLoading } = useQuery({
    queryKey: ['coax', 'masters'],
    queryFn: () => coax.masters(),
  });

  const online = list?.filter((m) => m.status === 'online').length ?? 0;
  const total  = list?.length ?? 0;

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <PageHeader
        title="Coax Masters"
        subtitle={total ? `${online}/${total} en ligne` : '…'}
      />

      <div className="flex-1 overflow-auto p-4">
        {isLoading ? (
          <div className="text-text-faint text-center py-12 italic">Chargement…</div>
        ) : !list?.length ? (
          <div className="card card-pad text-center py-12">
            <Antenna size={32} className="mx-auto text-text-faint mb-3" />
            <div className="text-sm font-semibold">Aucun Master coax</div>
            <div className="text-xs text-text-muted mt-1">Discover un Master via <code>php artisan coax:discover</code>.</div>
          </div>
        ) : (
          <div className="card overflow-hidden">
            <table className="w-full text-sm">
              <thead className="text-left text-xs text-text-muted bg-surface-hi">
                <tr>
                  <th className="px-3 py-2 font-medium">Master</th>
                  <th className="px-3 py-2 font-medium">Modèle</th>
                  <th className="px-3 py-2 font-medium">IP mgmt</th>
                  <th className="px-3 py-2 font-medium">NMU MAC</th>
                  <th className="px-3 py-2 font-medium">Firmware</th>
                  <th className="px-3 py-2 font-medium">EPs</th>
                  <th className="px-3 py-2 font-medium">Temp</th>
                  <th className="px-3 py-2 font-medium">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {list.map((m) => (
                  <tr
                    key={m.id}
                    className="hover:bg-surface-hi/40 cursor-pointer"
                    onClick={() => navigate(`/app/coax/masters/${m.id}`)}
                  >
                    <td className="px-3 py-2 font-medium">{m.name ?? `Master #${m.id}`}</td>
                    <td className="px-3 py-2 text-text-muted">{m.model}</td>
                    <td className="px-3 py-2 font-mono text-xs">{m.management_address}</td>
                    <td className="px-3 py-2 font-mono text-xs">{m.nmu_mac}</td>
                    <td className="px-3 py-2 text-text-muted">{m.nmu_firmware ?? '—'}</td>
                    <td className="px-3 py-2">
                      <span className="text-text">{m.ep_online}</span>
                      <span className="text-text-faint">/{m.ep_total}</span>
                    </td>
                    <td className="px-3 py-2">
                      {m.temperature_celsius != null ? (
                        <span className="inline-flex items-center gap-1 text-text-muted">
                          <Thermometer size={11} /> {m.temperature_celsius}°C
                        </span>
                      ) : '—'}
                    </td>
                    <td className="px-3 py-2">
                      {m.status === 'online' ? (
                        <span className="inline-flex items-center gap-1 text-emerald-400">
                          <CheckCircle2 size={12} /> online
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1 text-amber-400">
                          <AlertTriangle size={12} /> {m.status}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
